import { Icon } from '@iconify/react';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { NavLink, useMatches } from 'react-router-dom';

interface RouteHandle {
  breadcrumb?: string | ((params: Record<string, string | undefined>) => string);
}

export default function Breadcrumbs() {
  const matches = useMatches();

  const crumbs = matches
    .filter((match) => (match.handle as RouteHandle)?.breadcrumb)
    .map((match) => {
      const handle = match.handle as RouteHandle;
      const { breadcrumb } = handle;
      return {
        label: typeof breadcrumb === 'function' ? breadcrumb(match.params) : breadcrumb,
        path: match.pathname,
      };
    });

  if (!crumbs.length) return null;

  return (
    <Stack direction='row' flex={1} alignItems='center' gap={2}>
      <MuiBreadcrumbs separator={null} aria-label='breadcrumbs' color='grey.600'>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <Stack key={crumb.path} direction='row' gap={1.5} alignItems='center'>
              <Icon icon='ant-design:right-outlined' />
              {isLast ? (
                <>
                  <Typography color='inherit' fontWeight={500}>{crumb.label}</Typography>
                  <Icon icon='ant-design:right-outlined' />
                </>
              ) : (
                <MuiLink component={NavLink} to={crumb.path} underline='hover' color='inherit' fontWeight={500}>
                  {crumb.label}
                </MuiLink>
              )}
            </Stack>
          );
        })}
      </MuiBreadcrumbs>
    </Stack>
  );
}
